module.exports = __webpack_public_path__ + "static/img/6.c4636db5.png";